import React, { useEffect } from 'react';
import { Link, NavLink } from "react-router-dom";
import { FaMoon, FaSun, FaCode } from "react-icons/fa";
import "../styles/Vault.css";

export const VAULT_SUPPORT_EMAIL = 'rootaccess000@gmail.com';

export const VaultLayout = ({ title, meta, theme, onToggleTheme, children }) => {

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} · Vault`;
    window.scrollTo({ top: 0, behavior: 'auto' });
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div>
      <nav className="vault-nav">
        <div className="vault-nav-inner">
          <Link to="/" className="vault-brand">
            <FaCode size={24} style={{color: 'var(--color-coral)'}} />
            <span>erwin agpasa</span>
          </Link>
          <div className="vault-nav-links">
            <NavLink className="vault-nav-link" to="/vault/privacy">Privacy</NavLink>
            <NavLink className="vault-nav-link" to="/vault/support">Support</NavLink>
            <button
              type="button"
              className="btn btn-coral theme-toggle-btn"
              onClick={onToggleTheme}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
              title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            >
              {theme === 'dark' ? <FaSun aria-hidden="true" /> : <FaMoon aria-hidden="true" />}
            </button>
          </div>
        </div>
      </nav>

      <main className="vault-page">
        <header className="vault-header">
          <img src={require('../assets/img/vault-icon.png')} alt="Vault app icon" className="vault-icon" />
          <div>
            <h1>{title}</h1>
            <p className="vault-meta">{meta}</p>
          </div>
        </header>
        {children}
      </main>

      <footer className="vault-footer">
        Copyright &copy; {new Date().getFullYear()} Erwin Agpasa · Vault for iPhone
      </footer>
    </div>
  )
}
